@if (showBackButton$ | async) {
  <ds-results-back-button [back]="back"></ds-results-back-button>
}
<div class="d-flex flex-row">
  <ds-item-page-title-field class="me-auto" [item]="object">
  </ds-item-page-title-field>
  <ds-dso-edit-menu></ds-dso-edit-menu>
</div>

<div class="row mt-4">
  <div class="col-12 col-md-4">
    <ds-metadata-field-wrapper [hideIfNoTextContent]="false">
      @if (object.allMetadata(['person.thumbnail-url']).length > 0) {
        <div class="thumbnail limit-width ng-star-inserted" style="max-width:125px;">
          <img 
            class="thumbnail-content img-fluid ng-star-inserted" 
            attr.src="{{ object.allMetadata(['person.thumbnail-url'])[0].value }}">
          <small>(Fonte: Lattes)</small>
        </div>
      }

      @if (object.allMetadata(['person.thumbnail-url']).length < 1) {
        <ds-thumbnail [thumbnail]="object?.thumbnail | async"
          [defaultImage]="'assets/images/person-placeholder.svg'"
          [alt]="'thumbnail.person.alt'"
          [placeholder]="'thumbnail.person.placeholder'">
        </ds-thumbnail>
      }
    </ds-metadata-field-wrapper>

    @if (object.allMetadata(['person.identifier.lattes']).length > 0) {
      <div class="mb-1">
        <a attr.href="http://lattes.cnpq.br/{{ object.allMetadata(['person.identifier.lattes'])[0].value }}" target="_blank">
          <img src="assets/dspace/images/lattes.png" class="me-2 author-badge" />
          <strong>Lattes</strong>
        </a>
      </div>
    }

    @if (object.allMetadata(['person.identifier.orcid']).length > 0) {
      <div class="mb-1">
        <a attr.href="https://orcid.org/{{ object.allMetadata(['person.identifier.orcid'])[0].value }}" target="_blank">
          <img src="assets/dspace/images/orcid.png" class="me-2 author-badge" />
          <strong>ORCID</strong>
        </a>
      </div>
    }

    @if (object.allMetadata(['person.identifier.scopus-author-id']).length > 0) {
      <div class="mb-1">
        <a attr.href="https://www.scopus.com/authid/detail.uri?authorId={{ object.allMetadata(['person.identifier.scopus-author-id'])[0].value }}" target="_blank">
          <img src="assets/dspace/images/scopusid.png" class="me-2 author-badge" />
          <strong>Scopus</strong>
        </a>
      </div>
    }

    @if (object.allMetadata(['person.identifier.rid']).length > 0) {
      <div class="mb-1">
        <a attr.href="https://www.webofscience.com/wos/author/rid/{{ object.allMetadata(['person.identifier.rid'])[0].value }}" target="_blank">
          <img src="assets/dspace/images/researcherid.png" class="me-2 author-badge" />
          <strong>ResearcherID</strong>
        </a>
      </div>
    }
  </div>

  <div class="col-12 col-md-7">
    <ds-generic-item-page-field [item]="object"
      [fields]="['person.name.variant']"
      [label]="'person.page.variant'">
    </ds-generic-item-page-field>

    <ds-generic-item-page-field [item]="object"
      [fields]="['person.vinculo']"
      [label]="'person.page.vinculo'">
    </ds-generic-item-page-field>

    <div>
      <a class="btn btn-outline-primary" [routerLink]="[itemPageRoute + '/full']" role="button" tabindex="0">
        {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
  <div class="mt-5 w-100 px-0">
    <ds-tabbed-related-entities-search  [item]="object"
                                        [relationTypes]="[{
                                          label: 'isAuthorOfPublication',
                                          filter: 'isAuthorOfPublication',
                                          configuration: 'default-relationships'
                                        }]">
    </ds-tabbed-related-entities-search>
  </div>
</div>
